module.exports = "/_next/static/images/b38c7e2837986030aab5a715236820a9-cartao-proximo-ao-olho-xs@3x.jpg.webp";